import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class CheckinService {

  private baseUrl = environment.apibaseUrl;

  constructor(private http: HttpClient) { }

  addWaitingRoomCheckin(checkinData) {

    return this.http.post(this.baseUrl + '/waitingroom/checkin', checkinData);

  }

  public getClinicianList(clinicId) {

    return this.http.get(this.baseUrl + '/patient/Available-Clinician?clinicId=' + clinicId);

  }

  getCheckInInfo(patientId, waitingroomlevel) {
    return this.http.get(this.baseUrl + '/waitingroom/info?patientId=' + patientId + '&wrlt=' + waitingroomlevel);
  }


  getwaitingroomlimit(checkinData) {
    return this.http.post(this.baseUrl + '/waitingroom/Limit', checkinData);

  }
  leave_from_waiting_room(w_room_id, isCancel = false) {
    return this.http.post(this.baseUrl + '/waitingroom/leave', {
      waitingRoomId: w_room_id,
      isCancel: isCancel
    });

  }


  getclinicScheduleData(data) {
    return this.http.post(this.baseUrl + '/waitingroom/clinicScheduleData', data);
  }

  public getSocialWorkerAvailable(clinicId) {

    return this.http.get(this.baseUrl + '/waitingroom/getSocialWorkerAvailable?clinicId=' + clinicId);

  }
}
